import React, { FC } from 'react';
// icons
//icons
import { FiArrowUp } from 'react-icons/fi';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../../constants/aampeTheme';

const AddVariationMsg: FC<React.PropsWithChildren<unknown>> = () => {
    return (
        <Message>
            <ArrowIcon>
                <FiArrowUp color={aampeTheme.colors.secondary500} size={20} />
            </ArrowIcon>
            <HeaderText>
                Want to generate more messages? Add alternates.
            </HeaderText>
        </Message>
    );
};

export default AddVariationMsg;

const Message = styled.div(() => ({
    backgroundColor: aampeTheme.colors.white,
    padding: aampeTheme.spacing(2, 1),
    borderRadius: aampeTheme.borderRadius.default,
    display: 'flex',
    color: aampeTheme.colors.secondary500,
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
    width: '84%',
}));

const ArrowIcon = styled.div(() => ({
    backgroundColor: aampeTheme.colors.secondary100,
    borderRadius: '50%',
    padding: aampeTheme.spacing(1),
    border: `2px solid ${aampeTheme.colors.secondary25}`,
    display: 'flex',
}));

const HeaderText = styled.span(() => ({
    fontSize: '14px',
    fontWeight: 500,
    alignItems: 'center',
}));
